<template>
  <div>
    <logged-in-header />
    <scale-products />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import scaleProducts from "../components/scale-product/ScaleProducts";

export default {
  components: {
    loggedInHeader,
    scaleProducts
  }
};
</script>
